import { __ } from '@wordpress/i18n';
import {HeightControl, VayuBlocksBackground, VayuBlocksBorder, VayuBlocksDimensions} from '@vayu-blocks';
import { PanelBody } from '@wordpress/components';
import { SlideButton } from '@vayu-blocks/global';
import { useState } from 'react';

const Style = ({ attributes, setAttributes, openPanels, onTogglePanel }) => {

    const [hover, sethover] = useState('normal');
    
    const handelHover = (value) => {
        sethover(value);
    }

    return (
        
        <>

            <PanelBody
                title={__('Faq Container', 'vayu-blocks')}
                opened={openPanels['faq-container']}
                onToggle={() => onTogglePanel('faq-container')}
            >

                <VayuBlocksBackground
                    onChange={(key,value)=>setAttributes({[key]:value})}
                    colorPanel = {[
                        {
                            active: ['gradient'],
                            label: 'Container',
                            key:'containerbg',
                            value:attributes.containerbg,
                        },
                        {
                            active: ['gradient'],
                            label: 'Hover',
                            key:'containerbghvr',
                            value:attributes.containerbghvr,
                        },
                    ]}
                />

                <HeightControl
                    label={__('Rows gap', 'vayu-blocks')}
                    value={ attributes.rowgap }
                    onChange={ (value) => setAttributes({rowgap: value }) }
                    responsive={true}
                    unitMax={{
                                px: { max: 100, step: 1 },
                            }}
                    customUnits={['px']}
                />
                <br/>

                <SlideButton  
                    button={{ normal: "Normal", hover: "Hover" }}
                    onChange={(value)=>handelHover(value)}
                    defaultValue={hover}
                />  
        
                {hover === 'normal' && (
                    <VayuBlocksBorder
                        onChange={(key, value) => setAttributes({ [key]: value })}
                        border={{ key: 'contBorder', value: attributes.contBorder }}
                        borderRadius={{ key: 'contBorderRadius', value: attributes.contBorderRadius }}
                        dropShadow={{ key: 'contDropShadow', value: attributes.contDropShadow }}
                    />
                )}

                {hover === 'hover' && (
                    <VayuBlocksBorder
                        onChange={(key, value) => setAttributes({ [key]: value })}
                        border={{ key: 'contBorderHover', value: attributes.contBorderHover }}
                        borderRadius={{ key: 'contBorderRadiusHover', value: attributes.contBorderRadiusHover }}
                        dropShadow={{ key: 'contDropShadowHover', value: attributes.contDropShadowHover }}
                    />
                )}

            </PanelBody>

            {attributes.showtype != 'grid' && (
                <PanelBody
                    title={__('Icon', 'vayu-blocks')}
                    opened={openPanels['faq-icon']}
                    onToggle={() => onTogglePanel('faq-icon')}
                >

                    <HeightControl
                        label={__('Size', 'vayu-blocks')}
                        value={ attributes.iconsize }
                        onChange={ (value) => setAttributes({iconsize: value }) }
                        responsive={true}
                        unitMax={{
                                    px: { max: 100, step: 1 },
                                }}
                        customUnits={['px']}
                    />

                    <HeightControl
                        label={__('Top', 'vayu-blocks')}
                        value={ attributes.icontop }
                        onChange={ (value) => setAttributes({icontop: value }) }
                        responsive={true}
                    />

                    <HeightControl
                        label={__('Left', 'vayu-blocks')}
                        value={ attributes.iconleft }
                        onChange={ (value) => setAttributes({iconleft: value }) }
                        responsive={true}
                    />

                    <br/>

                    <VayuBlocksDimensions
                        onChange={(key, value) => setAttributes({ [key]: value })}
                        dimensions={{
                            padding: { key: 'iconPadding', value: attributes.iconPadding },
                        }}
                    />

                    <VayuBlocksBackground
                        onChange={(key,value)=>setAttributes({[key]:value})}
                        colorPanel = {[
                            {
                                active: ['gradient'],
                                label: 'Background',
                                key:'iconbg',
                                value:attributes.iconbg,
                            },
                            {
                                active: ['gradient'],
                                label: 'Hover Background',
                                key:'iconbghvr',
                                value:attributes.iconbghvr,
                            },
                            {
                                active: ['color'],
                                label: 'Color',
                                key:'iconcolor',
                                value:attributes.iconcolor,
                            },
                            {
                                active: ['color'],
                                label: 'Hover Color',
                                key:'iconcolorhvr',
                                value:attributes.iconcolorhvr,
                            },
                            {
                                active: ['color'],
                                label: 'Active Color',
                                key:'iconactivecolor',
                                value:attributes.iconactivecolor,
                            },
                        ]}
                    />

                    <VayuBlocksBorder
                        onChange={(key, value) => setAttributes({ [key]: value })}
                        border={{ key: 'iconBorder', value: attributes.iconBorder }}
                        borderRadius={{ key: 'iconBorderRadius', value: attributes.iconBorderRadius }}
                        dropShadow={{ key: 'iconDropShadow', value: attributes.iconDropShadow }}
                    />

                </PanelBody>
            )}
        </>

    );
};

export default Style;